import styled from 'styled-components';
import { Icon, Input } from 'antd';


export const PopoverWrapper = styled.div`
  width: 350px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const AssignBtn = styled.button`
  font-size: 14px;
  font-weight: normal;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.fontTangerine};
  outline: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:disabled {
    color: ${({ theme }) => theme.colors.backgroundDarkSilver};
    cursor: not-allowed;
  }
`;

export const ManageAssigneesBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px 0;
`;

export const ManageAssigneesBtn = styled(AssignBtn)`
  color: ${({ theme }) => theme.colors.fontSilverPrimary};
`;

export const Arrow = styled(Icon)`
  padding-left: 5px;
  color: ${({ theme }) => theme.colors.fontSilverPrimary};
`;

export const UserIcon = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  outline: none;
  margin-right: 5px;
`;

export const SearchInput = styled(Input)`
  margin-bottom: 15px;
  .ant-input {
    height: 38px;
    border-radius: 3rem;
  }
  .ant-input-suffix {
    z-index: unset;
  }
`;

export const UserRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
  padding: 0 5px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const UserInfo = styled.div`
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Title = styled.div`
  font-weight: 500;
`;

export const UsersListWrapper = styled.div`
  max-height: 165px;
  overflow-y: auto;
`;

export const AssigneesListWrapper = styled.div`
  padding-top: 15px;
`;

export const AssigneesEmptyList = styled.div`
  font-size: 12px;
  text-align: center;
  font-style: italic;
  padding: 15px 0 2px;
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-assignees/manage-assignees/styled-components.js